(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gv-immersive-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-gvx-section]');
    roots.forEach((root) => {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const reveal = root.querySelectorAll('.gvx-reveal');
      if (reduced) {
        reveal.forEach((item) => item.classList.add('is-visible'));
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      reveal.forEach((item) => observer.observe(item));
      if (window.matchMedia('(min-width: 750px)').matches) {
        const layers = root.querySelectorAll('.gvx-parallax img');
        let ticking = false;
        const update = () => {
          layers.forEach((image) => {
            const rect = image.parentElement.getBoundingClientRect();
            const offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * -0.035;
            image.style.transform = `translate3d(0, ${offset}px, 0) scale(1.07)`;
          });
          ticking = false;
        };
        window.addEventListener('scroll', () => {
          if (!ticking) {
            requestAnimationFrame(update);
            ticking = true;
          }
        }, { passive: true });
        update();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gvs-outfit-carousel"] && !Shopify.designMode) return;
  try {
    
function setupLookStages(root){
 root.querySelectorAll('.gv-outfits').forEach(section=>{
  if(section.dataset.ready)return;
  const track=section.querySelector('.gv-outfits-track'), cards=[...track.children], total=cards.length;
  if(!total)return;
  section.dataset.ready='1';
  const step=2*Math.PI/total, mod=n=>(n%total+total)%total;
  let phase=0, active=0, frame=0, drag=null, suppress=0;
  let width=track.clientWidth,height=track.clientHeight;
  function paint(){
    active=mod(Math.round(phase/step));
    cards.forEach((card,i)=>{
      const angle=i*step-phase, depth=(1+Math.cos(angle))/2;
      card.style.setProperty('--x', Math.sin(angle)*width*.392+'px');
      card.style.setProperty('--y', -(1-depth)*height*.54+'px');
      card.style.setProperty('--scale', .36+.64*depth);
      card.style.setProperty('--layer', Math.round(depth*1000));
      card.toggleAttribute('data-center',i===active);
      card.querySelector('.gv-look-open').tabIndex=i===active?0:-1;
    });
  }
  function announce(){section.querySelector('.gv-look-count').textContent=(active+1)+' / '+total+' · '+cards[active].querySelector('strong').textContent;}
  function turn(target){
    cancelAnimationFrame(frame);
    const from=phase,start=performance.now(),duration=matchMedia('(prefers-reduced-motion: reduce)').matches?0:340;
    function tick(now){
      const t=duration?Math.min(1,(now-start)/duration):1;
      phase=from+(target-from)*(1-(1-t)**3);paint();
      if(t<1)frame=requestAnimationFrame(tick);else announce();
    }
    frame=requestAnimationFrame(tick);
  }
  function select(index){
    const near=Math.round(phase/step), delta=mod(index-near);
    turn((near+(delta>total/2?delta-total:delta))*step);
  }
  section.querySelectorAll('[data-step]').forEach(b=>b.onclick=()=>turn((Math.round(phase/step)+Number(b.dataset.step))*step));
  track.addEventListener('dragstart',e=>e.preventDefault());
  track.addEventListener('pointerdown',e=>{
    if(section.hasAttribute('data-focus')||!e.isPrimary||e.button!==0||e.target.closest('dialog'))return;
    cancelAnimationFrame(frame);drag={id:e.pointerId,x:e.clientX,y:e.clientY,phase,moved:false};
  });
  track.addEventListener('pointermove',e=>{
    if(!drag||drag.id!==e.pointerId)return;
    const dx=e.clientX-drag.x,dy=e.clientY-drag.y;
    if(!drag.moved){
      if(Math.abs(dy)>8&&Math.abs(dy)>Math.abs(dx)){drag=null;return;}
      if(Math.abs(dx)<5)return;
      drag.moved=true;track.setPointerCapture(e.pointerId);
    }
    phase=drag.phase-dx*step/Math.max(54,width*.22);paint();
  });
  function release(e){
    if(!drag||e.pointerId!==drag.id)return;
    if(drag.moved){suppress=Date.now()+420;turn(Math.round(phase/step)*step);}
    drag=null;
  }
  track.addEventListener('pointerup',release);track.addEventListener('pointercancel',release);
  track.addEventListener('pointerleave',e=>{if(drag&&!drag.moved)release(e);});
  track.addEventListener('keydown',e=>{if(section.hasAttribute('data-focus')||!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();const next=mod(active+(e.key==='ArrowRight'?1:-1));select(next);cards[next].querySelector('button').focus({preventScroll:true});});
  const observer=new ResizeObserver(()=>{width=track.clientWidth;height=track.clientHeight;paint();});observer.observe(track);
  section.addEventListener('shopify:section:unload',()=>{observer.disconnect();cancelAnimationFrame(frame);});
  const detailNav=section.querySelector('.gv-look-detail-nav');
  const entries=cards.map(card=>{
    const button=card.querySelector('.gv-look-open');
    const panel=document.getElementById(button.getAttribute('aria-controls'));
    return {card,button,panel,close:panel.querySelector('[data-close]')};
  });
  let picked=null;
  function leaveLook(){
    if(picked===null)return;
    const entry=entries[picked];
    entry.panel.hidden=true;entry.card.removeAttribute('data-picked');entry.button.setAttribute('aria-expanded','false');
    section.removeAttribute('data-focus');detailNav.hidden=true;cards.forEach(card=>card.inert=false);
    picked=null;paint();entry.button.focus({preventScroll:true});
  }
  function openLook(index,focusTarget){
    cancelAnimationFrame(frame);drag=null;
    if(picked!==null){
      const previous=entries[picked];previous.panel.hidden=true;previous.card.removeAttribute('data-picked');previous.button.setAttribute('aria-expanded','false');
    }
    picked=mod(index);phase=picked*step;paint();announce();
    const entry=entries[picked];
    cards.forEach(card=>card.inert=card!==entry.card);
    section.setAttribute('data-focus','');entry.card.setAttribute('data-picked','');
    entry.button.setAttribute('aria-expanded','true');entry.panel.hidden=false;detailNav.hidden=total<2;
    (focusTarget||entry.close).focus({preventScroll:true});
  }
  detailNav.querySelectorAll('[data-look-step]').forEach(button=>{
    button.onclick=()=>{if(picked!==null)openLook(picked+Number(button.dataset.lookStep),button);};
  });
  section.addEventListener('keydown',event=>{
    if(picked===null)return;
    if(event.key==='Escape'){event.preventDefault();leaveLook();return;}
    if(!['ArrowLeft','ArrowRight'].includes(event.key)||event.target.closest('select,input,textarea,[contenteditable="true"]'))return;
    event.preventDefault();
    const direction=event.key==='ArrowRight'?1:-1;
    openLook(picked+direction,detailNav.querySelector('[data-look-step="'+direction+'"]'));
  });
  cards.forEach((card,i)=>{
   const {button:b,panel:dlg,close}=entries[i];
   b.onclick=()=>{if(Date.now()<suppress)return;if(picked===i){leaveLook();return;}openLook(i);};
   close.onclick=leaveLook;
   dlg.querySelectorAll('[data-plus]').forEach(plus=>{plus.onclick=async()=>{
     const form=plus.closest('form'),selector=plus.closest('.gv-piece').querySelector('select'),status=form.querySelector('[role=status]'),de=dlg.dataset.lang==='de';
     if(plus.disabled)return;
     if(!selector.value){selector.focus();selector.reportValidity();return;}
     plus.disabled=true;status.textContent='';
     try{
       const res=await fetch(form.action+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(selector.value),quantity:1}]})});
       if(!res.ok)throw Error((await res.json()).description||res.statusText);
       status.textContent=(de?'Hinzugefügt: ':'Added: ')+plus.closest('.gv-piece').querySelector('a span').firstChild.textContent+' · '+selector.selectedOptions[0].textContent.split(' · ')[0];
     }catch(err){status.textContent=err.message;}finally{plus.disabled=false;}
   };});
   const form=dlg.querySelector('form');if(form)form.onsubmit=async e=>{e.preventDefault();const buy=form.querySelector('[data-buy]');if(buy.disabled)return;buy.disabled=true;try{const items=[...form.querySelectorAll('select')].map(s=>({id:Number(s.value),quantity:1}));const res=await fetch(form.action+'.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});if(!res.ok)throw Error((await res.json()).description||res.statusText);const root=window.Shopify?.routes?.root||'/';const code=form.dataset.code;window.location.assign(code?root+'discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(root+'cart'):root+'cart')}catch(err){form.querySelector('[role=status]').textContent=err.message;buy.disabled=false}};
  });paint();announce();
  function syncHash(){if(location.hash==='#outdoor'){const n=cards.findIndex(c=>c.id==='outdoor');if(n>=0)select(n)}}syncHash();window.addEventListener('hashchange',syncHash);
 });
}
setupLookStages(document);document.addEventListener('shopify:section:load',e=>setupLookStages(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
